export default __webpack_public_path__ + "static/media/aifa-mobile-app.6a990771.jpeg";